// React import removed
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { OrderDetailsContent } from '@/pageContents/customers/orderDetails/OrderDetailsContent';
import { useParams } from 'react-router-dom';

const OrderDetailsPage: PageWithLayout = () => {
    const { customerId, orderId } = useParams();

    if (!customerId || !orderId) {
        return null;
    }

    return (
        <>
            <Helmet>
                <title>Bestellung Details | Starjack Backoffice</title>
            </Helmet>

            <OrderDetailsContent customerId={customerId} orderId={orderId} />
        </>
    );
};

OrderDetailsPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
OrderDetailsPage.isProtected = true;

OrderDetailsPage.permissions = [Permission.CUSTOMER_NAV, Permission.SUPPORTER];

export default OrderDetailsPage;
